
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class BooksGrid extends Serenity.EntityGrid<BooksRow, any> {
        protected getColumnsKey() { return BooksColumns.columnsKey; }
        protected getDialogType() { return BooksDialog; }
        protected getIdProperty() { return BooksRow.idProperty; }
        protected getInsertPermission() { return BooksRow.insertPermission; }
        protected getLocalTextPrefix() { return BooksRow.localTextPrefix; }
        protected getService() { return BooksService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}